import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import TransitionContainer from '../../components/Transition/TranstionContainer';

import VoteRegistrationStep7Form from '../../components/VoteRegistration/VoteRegistrationStep7Form';

import { onGoToStep, saveForm } from './actions';
import { cacheFormData } from '../../utils/formCaching/actions';
import {
    widgetBounce,
    setExitingCardProps,
    getExitingCardProps
} from '../Widget/actions';

import {
    ContainerStyled,
    LegalInfoWrapper,
    FormWrapper
} from '../DefaultStyles/AssessmentDetails';

import { StatesId } from '../../utils/enums';

import VoteRegistrationSidebar from '../../components/VoteRegistration/VoteRegistrationSidebar';

import LegalInfo from '../../components/Widget/LegalInfo';

const VoteRegistrationStep7 = props => (
    <TransitionContainer
        isSubmitting={props.isSubmitting}
        isBackTransition={props.isBackTransition}
        zIndex={32}
    >
        <ContainerStyled>
            <VoteRegistrationSidebar loadRep={true} title={'Voter Registration'} />
            <FormWrapper>
                <VoteRegistrationStep7Form
                    onBack={() => {
                        if (!props.bounceDismissed) {
                            props.widgetBounce(
                                true,
                                props.widgetRequestId,
                                props.articleUrl,
                                props.currentFormValues,
                                props.actionIdentifier
                            );
                        } else {
                            props.setExitingCardProps(
                                'voteRegistration',
                                props,
                                props.activeAction
                            );
                            props.onGoToStep(
                                6,
                                'back',
                                null,
                                null,
                                [4, 5, 6],
                                props.formData
                            );
                        }
                    }}
                    onSubmit={values => {
                        props.cacheFormData(values);
                        props.setExitingCardProps(
                            'voteRegistration',
                            props,
                            props.activeAction
                        );
                        props.saveForm(values, [8], null, props.formData);
                    }}
                    states={props.states}
                    validationErrors={props.validationErrors}
                />
                {props.isMobileResolution && (
                    <LegalInfoWrapper>
                        <LegalInfo />
                    </LegalInfoWrapper>
                )}
            </FormWrapper>
        </ContainerStyled>
    </TransitionContainer>
);

VoteRegistrationStep7.propTypes = {
    activeAction: PropTypes.object.isRequired,
    onGoToStep: PropTypes.func.isRequired,
    saveForm: PropTypes.func.isRequired,
    formData: PropTypes.object,
    states: PropTypes.array,
    isSubmitting: PropTypes.bool,
    isBackTransition: PropTypes.bool,
    isMobileResolution: PropTypes.bool,
    cacheFormData: PropTypes.func.isRequired,
    setExitingCardProps: PropTypes.func.isRequired,
    bounceDismissed: PropTypes.bool.isRequired,
    actionIdentifier: PropTypes.string.isRequired,
    currentFormValues: PropTypes.object.isRequired,
    articleUrl: PropTypes.string.isRequired,
    widgetRequestId: PropTypes.string.isRequired,
    widgetBounce: PropTypes.func.isRequired,
    validationErrors: PropTypes.object
};

export default connect(
    (state, props) => {
        const exitingProps = getExitingCardProps(
            'voteRegistration',
            ['/voteRegistration/step7'],
            props.location.pathname,
            state
        );
        if (exitingProps) return exitingProps;

        return {
            activeAction: state.widget.activeAction,
            formData: state.voteRegistration.formData,
            states: StatesId,
            isSubmitting: state.voteRegistration.isSubmitting,
            isBackTransition: state.voteRegistration.isBackTransition,
            isMobileResolution: state.widget.isMobileResolution,
            actionIdentifier: state.widget.activeAction.identifier,
            bounceDismissed: state.widget.bounceDismissed,
            widgetRequestId: state.widget.widgetRequestId,
            articleUrl: state.widget.articleUrl,
            currentFormValues: (state.form['voteRegistrationStep7Form'] || {}).values,
            validationErrors: (state.form['voteRegistrationStep7Form'] || {}).syncErrors
        };
    },
    { widgetBounce, onGoToStep, saveForm, cacheFormData, setExitingCardProps }
)(VoteRegistrationStep7);
